<template>
  <section>
    <stepper-step
      :complete="complete"
      :title="`Select languages for ${site.hostname}`"
      subtitle="Select from the below list of languages that are available for the selected site."
      :step="$props.step"
      :editable="currentStep >= 3"
    />

    <v-stepper-content v-bind="$props" v-on="$listeners">
      <div class="pt-4 d-flex">
        <select-list
          :value="formattedValue"
          :is-disabled="loading"
          :is-loading="loading"
          :items="languageOptions"
          label="Languages"
          class="mr-4 mb-4 flex-grow-1"
          hide-details
          multiple
          @input="onChange"
        />
        <v-btn v-if="showButton" color="primary" :loading="loading" :disabled="!complete" @click="onContinue">
          Continue
        </v-btn>
      </div>
    </v-stepper-content>
  </section>
</template>

<script>
import { VStepperContent } from 'vuetify/lib'

import StepperStep from './stepper-step.vue'
import SelectList from '@/components/forms/select-list'

export default {
  name: 'StepperLanguageStep',
  components: { StepperStep, SelectList },
  extends: VStepperContent,
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    value: {
      type: [Array, Object, null],
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    siteId: {
      type: String,
      required: true,
    },
    sites: {
      type: Array,
      required: true,
    },
    languageSites: {
      type: Array,
      required: true,
    },
    showButton: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    site() {
      return this.sites.find(({ id }) => id == this.siteId)
    },
    languageOptions() {
      return this.languageSites
        .filter(({ site_id }) => site_id == this.siteId)
        .map(({ language: { id: value, name: key } }) => ({ value, key }))
    },
    complete() {
      return Object.entries(this.formData.sites).every(([siteId, languages]) => Object.entries(languages).length > 0)
    },
    formattedValue() {
      return Object.keys(this.value).map(val => parseInt(val))
    },
  },
  methods: {
    onChange(items) {
      this.$emit(
        'change',
        items.reduce((o, key) => Object.assign(o, { [key]: [] }), {})
      )
    },
    onContinue() {
      this.$emit('increment')
    },
  },
}
</script>
